// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2_dzL","fileBtn":"File_fileBtn__1J-tw","closeBtn":"File_closeBtn__2O3_i","fileSelected":"File_fileSelected__3bCS6","disabled":"File_disabled__1yO3C"};